import * as yup from 'yup';

// Schémas de validation Yup
const companyNameValidationSchema = yup.object().shape({
    companyName: yup.string().required('La dénomination est requise')
});

export default companyNameValidationSchema